import { AlgoliaModelMapper } from "@api/mappers/products.mapper";

import { AlgoliaSearchResponse } from "@services/algolia/types/search.types";

import { ProductAlgoliaModel } from "../../../../@types/service/product/algolia/product.algolia.model";

const getProductsFromResponse = ({
    results,
}: AlgoliaSearchResponse<ProductAlgoliaModel>) => {
    const products = results.at(0);

    return products?.hits.map(AlgoliaModelMapper) ?? [];
};

export { getProductsFromResponse };
